import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import BasicInfo from '@/features/order/components/orderInfo/BasicInfo';
import OrderStyles from '@/features/order/components/orderInfo/OrderStyles';

const PoAutomationDetails = () => {
	const location = useLocation();
	const reduxData = useSelector((state) => state.product?.poAutomationResponse || {});
	const collectionId = location?.state?.collectionId || null;
	const folderId = location?.state?.folderId || null;
	const poDocIdList = location?.state?.poDocIdList || null;
	const [basicInfoData, setBasicInfoData] = useState(null);
	const localData = (() => {
		if (typeof window === 'undefined') return {};
		try {
			return JSON.parse(localStorage.getItem('poAutomationData') || '{}');
		} catch {
			return {};
		}
	})();

	// Priority: navigation state > redux > localStorage
	const locationData = location?.state?.data || {};
	const productData = locationData?.orderPrefill
		? locationData
		: reduxData?.orderPrefill
			? reduxData
			: localData;
	const { orderPrefill, designs, brandId, extractionResultId } = productData;

	// Save to localStorage when Redux data changes
	useEffect(() => {
		if (reduxData?.orderPrefill) {
			localStorage.setItem('poAutomationData', JSON.stringify(reduxData));
		}
	}, [reduxData]);

	// useMemo prevents a new object reference on every render — this was causing the infinite loop
	const prefillData = useMemo(
		() =>
			orderPrefill
				? {
						projectDetails: {
							name: (Array.isArray(designs) && designs[0]?.title) || '',
							startDate: orderPrefill.poReceivedDate || '',
							deliveryDate: orderPrefill.etd || '',
							season: orderPrefill.season || '',
							incotermsLocation: orderPrefill.incotermsLocation || '',
							buyerResponse: { email: '' },
							brandResponse: { id: null }
						},
						selectedSalesChannel: orderPrefill.revenueStream
							? { value: orderPrefill.revenueStream, id: orderPrefill.revenueStream }
							: '',
						selectedIncoTerm: orderPrefill.incotermsEnum
							? {
									value: orderPrefill.incotermsEnum,
									id: orderPrefill.incotermsEnum,
									label: orderPrefill.incotermsEnum
								}
							: '',
						selectedProjectManager: '',
						selectedAccountManager: '',
						selectedSubBrand: '',
						poDocuments: []
					}
				: null,

		[orderPrefill]
	);

	return (
		<div className="create-container-with-add-people w-100">
			<div className="body-content">
				<div className="create-order-container p-3 basic-order-section">
					<div className="common-accordion">
						<div className="order-single-accordion">
							<BasicInfo
								prefillData={prefillData}
								updateButtonOff={true}
								onBasicInfoDataChange={setBasicInfoData}
								brandId={brandId}
								isFromPoAutomation={true}
							/>
							<OrderStyles
								automationDesigns={designs}
								isDrafted={true}
								collectionId={collectionId}
								folderId={folderId}
								poSubmitButton={true}
								poDocIdList={poDocIdList}
								basicInfoData={basicInfoData}
								isFromPoAutomation={true}
								brandId={brandId}
								extractionResultId={extractionResultId}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default PoAutomationDetails;
